var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.root},[_c('SectionTitle',{class:_vm.$style.title,attrs:{"prefix":_vm.prefix,"title":_vm.title,"subtitle":_vm.subtitle}}),_c('div',{ref:"body",class:_vm.$style.body,style:({ transform: ("translate3d(0, " + _vm.scrollAmount + "px, 0)") })},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f5979e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/assets/js/components/Section/index.vue
// module id = Mwj0
// module chunks = 2